import { IoAlertCircle } from "react-icons/io5";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: ${({ width }) => (width ? width : "100%")};
  height: ${({ height }) => (height ? height : "100%")};
  padding: 0.9rem;
  gap: 0.5rem;
  flex-direction: column;
  border-radius: 8px 8px 0 0;
  background-color: #f6f6f6;
  box-shadow: 0 2px 4px -1px rgb(0 0 0 / 20%), 0 4px 5px 0 rgb(0 0 0 / 14%),
    0 1px 10px 0 rgb(0 0 0 / 12%);
  .input--search {
    height: 2.5rem;
  }
  .selected {
    background-color: #1d86ff;
    color: #ffff;
  }
`;
export const ViewMessage = styled.ul`
  width: 100%;
  height: 100%;
  padding: 0.5rem 0.2rem;
  overflow-y: auto;
  background: #ffffff;
  border-radius: 6px;

  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(0, 0, 0, 0.2);
  }
`;
// export const TextMessage = styled.li`
//   list-style: none;
//   user-select: none;
//   cursor: pointer;
//   width: 100%;
//   margin: 0;
//   padding: 0.5rem 1rem;
//   border: 0 none;
//   color: #495057;
//   transition: box-shadow 0.2s;
//   border-radius: 0;
//   &:hover {
//     color: #495057;
//     background: #e9ecef;
//   }
// `;

export const TextMessage = styled.li`
  display: flex;
  align-items: center;
  list-style: none;
  user-select: none;
  cursor: pointer;
  width: 100%;
  margin: 0 0 0.2rem 0;
  padding: 0.5rem;
  border: 1px solid transparent;
  color: #2c3e50;
  transition: all 0.3s ease;
  border-radius: 8px;
  position: relative;
  background: #ffffff;
  overflow: hidden;
  gap: 0.5rem;

  &:hover {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-color: rgba(29, 134, 255, 0.2);
    transform: translateY(-2px);
    &::before {
      background: linear-gradient(180deg, #1d86ff 0%, #0056b3 100%);
    }
  }

  &:last-child {
    margin-bottom: 0;
  }

  > p {
    flex: 1;
    margin: 0;
    padding-left: 0.8rem;
    line-height: 1.3;
    font-size: 0.95rem;
    color: #495057;
    text-align: justify;
  }
`;
export const TypeTemplate = {
  MARKETING: styled(IoAlertCircle)`
    color: #fa2c36;
    font-size: 1.5rem;
    flex-shrink: 0;
    margin-top: 0.1rem;
    transition: all 0.3s ease;

    ${TextMessage}:hover & {
      transform: scale(1.1);
    }
  `,
  UTILITY: styled(IoAlertCircle)`
    color: #00c951;
    font-size: 1.5rem;
    flex-shrink: 0;
    margin-top: 0.1rem;
    transition: all 0.3s ease;

    ${TextMessage}:hover & {
      transform: scale(1.1);
    }
  `,
  DEFAULT: styled(IoAlertCircle)`
    color: #9da0a3;
    font-size: 1.5rem;
    flex-shrink: 0;
    margin-top: 0.1rem;
    transition: all 0.3s ease;

    ${TextMessage}:hover & {
      transform: scale(1.1);
    }
  `,
};
export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #6c757d;
  text-align: center;
  padding: 2rem;

  svg {
    font-size: 3rem;
    margin-bottom: 1rem;
    opacity: 0.5;
  }

  h3 {
    margin: 0 0 0.5rem 0;
    font-size: 1.1rem;
    font-weight: 600;
    color: #495057;
  }

  p {
    margin: 0;
    font-size: 0.9rem;
    opacity: 0.8;
  }
`;
export const FiltersType = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;

  > button {
    border: 0 none;
    background: transparent;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 0.4rem 1rem;
    border-radius: 4px;
    border: 1px solid transparent;
    &:hover {
      background: #e9ecef;
    }
  }
  .dfl {
    color: #9da0a3;
    border-color: #9da0a3;

    &:hover {
      background: #9da0a3;
      color: #ffffff;
    }
  }
  .dfl-sel {
    background: #9da0a3;
    color: #ffffff;
  }
  .mkt {
    color: #fa2c36;
    border-color: #fa2c36;

    &:hover {
      background: #fa2c36;
      color: #ffffff;
    }
  }
  .mkt-sel {
    background: #fa2c36;
    color: #ffffff;
  }
  .uly {
    color: #00c951;
    border-color: #00c951;

    &:hover {
      background: #00c951;
      color: #ffffff;
    }
  }
  .uly-sel {
    background: #00c951;
    color: #ffffff;
  }

  .mkt-description {
    font-size: 12px;
    color: #fa2c36;
  }
`;
